@if (type !== 'time') {
    <button
        mat-button
        type="button"
        class="mtx-calendar-header-year"
        [class.active]="currentView === 'year' || currentView === 'multi-year'"
        [attr.aria-label]="_yearButtonLabel"
        (click)="_yearClicked()">
        <span>{{ _yearButtonText }}</span>
        @if (multiYearSelector || type === 'year') {
            <svg
                class="mtx-calendar-header-year-dropdown"
                matButtonIcon
                iconPositionEnd
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor">
                <path d="M7,10L12,15L17,10H7Z" />
            </svg>
        }
    </button>
}
@if (type !== 'year') {
    <div class="mtx-calendar-header-date-time">
        @if (type !== 'time') {
            <button
                mat-button
                type="button"
                class="mtx-calendar-header-date"
                [class.active]="currentView === 'month'"
                [class.not-clickable]="type === 'month'"
                [attr.aria-label]="_dateButtonLabel"
                (click)="_dateClicked()">
                {{ _dateButtonText }}
            </button>
        }
        @if (type.endsWith('time')) {
            <span
                class="mtx-calendar-header-time"
                [class.active]="currentView === 'clock'">
                <span class="mtx-calendar-header-hour-minute-container">
                    <button
                        mat-button
                        type="button"
                        class="mtx-calendar-header-hours"
                        [class.active]="_clockView === 'hour'"
                        [attr.aria-label]="_hourButtonLabel"
                        (click)="_hoursClicked()">
                        {{ _hoursButtonText }}
                    </button>
                    <span class="mtx-calendar-header-hour-minute-separator">:</span>
                    <button
                        mat-button
                        type="button"
                        class="mtx-calendar-header-minutes"
                        [class.active]="_clockView === 'minute'"
                        [attr.aria-label]="_minuteButtonLabel"
                        (click)="_minutesClicked()">
                        {{ _minutesButtonText }}
                    </button>
                </span>
                @if (twelvehour) {
                    <span class="mtx-calendar-header-ampm-container">
                        <button
                            mat-button
                            type="button"
                            class="mtx-calendar-header-ampm"
                            aria-label="AM"
                            [class.active]="_AMPM === 'AM'"
                            (click)="_ampmClicked('AM')">
                            AM
                        </button>
                        <button
                            mat-button
                            type="button"
                            class="mtx-calendar-header-ampm"
                            aria-label="PM"
                            [class.active]="_AMPM === 'PM'"
                            (click)="_ampmClicked('PM')">
                            PM
                        </button>
                    </span>
                }
            </span>
        }
    </div>
}
<st-combo-box
    class="st-date-time-picker-custom-header__time-zone"
    [placeholder]="timeZoneLabel$ | ngrxPush"
    [label]="timeZoneLabel$ | ngrxPush"
    [itemList]="dateTimePicker.commonTimeZones()"
    [additionalItemList]="dateTimePicker.ianaTimeZones()"
    [value]="dateTimePicker.getTimeZone()"
    (changed)="dateTimePicker.timezoneChanged($event)" />
